import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { AuthorPublisherView } from "./AuthorPublisherView";
import { AuthorPublisherViewStore } from "../../store/AuthorPublisherViewStore";
import { useStore } from "../../../../hooks";

export const AuthorPublisherViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/authorPublisher/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new AuthorPublisherViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <AuthorPublisherView authorPublisherViewStore={store} />
      </PageLayout>
    </div>
  );
});
